"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateInput = exports.useDateInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("./DateInput.css");
var Popover_1 = require("../../components/Popover");
var R = __importStar(require("../../utils/ramda"));
var DatePicker_1 = require("../../components/DatePicker");
var date_fns_1 = require("date-fns");
var classnames_1 = __importDefault(require("classnames"));
var locale_1 = require("../../utils/locale");
var useDateInput = function (startingDate) {
  var _a = __read((0, react_1.useState)(""), 2),
    text = _a[0],
    setText = _a[1];
  var _b = __read((0, react_1.useState)(startingDate), 2),
    date = _b[0],
    onChange = _b[1];
  var _c = __read((0, react_1.useState)(false), 2),
    shown = _c[0],
    setShown = _c[1];
  var _d = __read((0, react_1.useState)(true), 2),
    valid = _d[0],
    setValid = _d[1];
  return {
    date: date,
    onChange: onChange,
    shown: shown,
    valid: valid,
    text: text,
    setShown: setShown,
    setValid: setValid,
    setText: setText
  };
};
exports.useDateInput = useDateInput;
var DateInput = function (_a) {
  var _b, _c;
  var datePickerProps = _a.datePickerProps,
    popoverProps = _a.popoverProps,
    date = _a.date,
    _d = _a.onChange,
    onChange = _d === void 0 ? R.N : _d,
    _e = _a.onBlur,
    onBlur = _e === void 0 ? R.N : _e,
    _f = _a.onFocus,
    onFocus = _f === void 0 ? R.N : _f,
    _g = _a.onClick,
    onClick = _g === void 0 ? R.N : _g,
    _h = _a.onInput,
    onInput = _h === void 0 ? R.N : _h,
    _j = _a.onKeyDown,
    onKeyDown = _j === void 0 ? R.N : _j,
    _k = _a.dateFormat,
    dateFormat = _k === void 0 ? "dd-MMM-yyyy" : _k,
    _l = _a.startFocused,
    startFocused = _l === void 0 ? false : _l,
    shown = _a.shown,
    valid = _a.valid,
    setValid = _a.setValid,
    setShown = _a.setShown,
    setText = _a.setText,
    className = _a.className,
    dateText = _a.text,
    restProps = __rest(_a, ["datePickerProps", "popoverProps", "date", "onChange", "onBlur", "onFocus", "onClick", "onInput", "onKeyDown", "dateFormat", "startFocused", "shown", "valid", "setValid", "setShown", "setText", "className", "text"]);
  var trySetDate = function (text) {
    if (R.isNothing(text)) {
      setValid(true);
      onChange(undefined);
      return;
    }
    var parsedDate = (0, date_fns_1.parse)(text, dateFormat, new Date(), {
      locale: (0, locale_1.getLocale)(datePickerProps === null || datePickerProps === void 0 ? void 0 : datePickerProps.locale)
    });
    var val = (0, date_fns_1.isValid)(parsedDate);
    if (val) {
      setValid(true);
      onChange(parsedDate);
    } else {
      setValid(false);
    }
  };
  var inputRef = (0, react_1.useRef)(null);
  (0, react_1.useEffect)(function () {
    var _a;
    setText(date ? (0, date_fns_1.format)(date, dateFormat) : "");
    startFocused && ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus());
  }, []);
  (0, react_1.useEffect)(function () {
    setText(date ? (0, date_fns_1.format)(date, dateFormat) : "");
  }, [date]);
  return (0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({}, popoverProps, {
    customColor: (_b = popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.customColor) !== null && _b !== void 0 ? _b : "#bfc0c2",
    contentStyle: {
      padding: 0
    },
    shown: shown,
    wrapperProps: __assign(__assign({}, popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.wrapperProps), {
      style: __assign({
        width: "200px"
      }, (_c = popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.wrapperProps) === null || _c === void 0 ? void 0 : _c.style)
    }),
    content: shown && (0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, __assign({}, datePickerProps, {
      style: {
        border: "none"
      },
      date: date,
      onChange: function (d) {
        var _a;
        setValid(true);
        onChange(d);
        setText(d ? (0, date_fns_1.format)(d, dateFormat) : "");
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      }
    })),
    onClickOutside: function () {
      return setShown(false);
    },
    maxWidth: 500
  }, {
    children: (0, jsx_runtime_1.jsx)("input", __assign({}, restProps, {
      type: "text",
      role: "textbox",
      ref: inputRef,
      className: (0, classnames_1.default)("vsx-date-input", !valid && "error", className),
      onFocus: function (e) {
        onFocus(e);
        setShown(true);
      },
      onClick: function (e) {
        onClick(e);
        setShown(true);
      },
      onKeyDown: function (e) {
        onKeyDown(e);
        if (e.key === "Enter") {
          e.preventDefault();
          setShown(false);
          trySetDate(dateText);
        }
      },
      onBlur: function (e) {
        onBlur(e);
        trySetDate(dateText);
      },
      onInput: function (e) {
        onInput(e);
        setShown(false);
        setText(e.currentTarget.value);
      },
      onChange: R.N,
      value: dateText,
      readOnly: false
    }))
  }));
};
exports.DateInput = DateInput;